const getMediaQuery = size => `@media (min-width: ${size}px)`;

export const Breakpoints = {
  small: getMediaQuery('320'),
  medium: getMediaQuery('640'),
  large: getMediaQuery('1024'),
  xlarge: getMediaQuery('1200'),
  xxlarge: getMediaQuery('1440'),
};
